<template>
  <!-- <section class="data-section"> -->
  <div class="contact-us Quick-Links">
    <p class="menu-title">
      Quick Links
      <img
        class="fenge"
        style="width: calc(100% - 210px) !important"
        src="../../assets/images/fenge.png"
      />
    </p>
    <ul class="footer-list">
      <li class="footer-list-item" v-for="(item, index) in list" :key="index">
        <span @click="toLink(item, index)" :href="item.addr_url">
          {{ item.addr_name }}</span
        >
      </li>
    </ul>
  </div>
  <!-- </section> -->
</template>

<script>
export default {
  name: "InfoCount",
  data() {
    return {
      list: [],
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      let ucode = "3b140f1f61774d948b1b97370b2be187";
      let url = `${window._CONFIG["domianURL"]}xmu/index/getData/${ucode}?is_hide=0&column=id&order=desc&pageNo=1&pageSize=10`;
      let params = {
        pageNo: 1,
        pageSize: 999,
        is_publish: 1,
        column: "id",
        order: "desc",
        superQueryMatchType: "and",
      };
      this.$axios({
        method: "get",
        url: url,
        params: params,
      }).then((res) => {
        let data = res.data.result.records;
        this.list = data;
        console.log(`links`, data);
      });
    },
    toLink(item, index) {
      console.log(`toLink`, item.addr_name);
      // var newStr = val.split(" ");
      // for (var i = 0; i < newStr.length; i++) {
      //   newStr[i] =
      //     newStr[i].slice(0, 1).toUpperCase() +
      //     newStr[i].slice(1).toLowerCase();
      // }
      // this.fromName = newStr.join(" ");
      window.localStorage.setItem(`pro__pid`, index);
      this.$router.push({
        path: "/detail",
        query: {
          title: item.addr_name,
          name: item.addr_url,
          ucode: item.code,
        },
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.contact-us {
  font-size: 18px;
  color: #1e1e1e !important;
}

.menu-title {
  font-size: 30px;
  color: #003a7e;
}

.fenge {
  width: 194px !important;
}

.footer-list {
  margin: 0;

  li {
    list-style-type: none;
    text-indent: -34px;
    padding-left: 34px;
    font-weight: 400;
    font-size: 16px;
    margin-bottom: 22px;
    cursor: pointer;

    a {
      vertical-align: middle;
      color: #1e1e1e;
      text-decoration: none;
    }
  }
}

.footer-list li :before {
  width: 15px;
  margin-right: 12px;
  background: #a4b9d1;
  display: inline-block;
  vertical-align: middle;
  content: "";
  height: 2px;
  transition: inherit;
}
</style>
